@if (prAnalyzer$ | async; as data) {
  @if (data.length > 0) {
    <div class="pr-analyzer-graph">
      <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
        <mat-icon>insert_chart_outlined</mat-icon>
        <div>
          <span>露出状況</span>
        </div>
        <mat-icon
          class="help"
          matTooltip="上記カレンダーで期間指定された範囲のテレビ、ウェブの露出状況をグラフ化しています。"
          >help_outline</mat-icon
          ><app-csv-download
          [id]="csvId"
          [fileName]="csvFileName"
          [csv]="csvData$ | async"
          [loading]="isCsvLoading$ | async"
          [artist]="selectedArtist$ | async"
        ></app-csv-download>
      </div>
      <mat-card>
        @if (prAnalyzerTypes$ | async; as labels) {
          <div
            fxLayout
            fxFlex="1 1 auto"
            fxLayoutAlign="center center"
            class="container"
            #container
            >
            @if (!(isLoading$ | async)) {
              <div
                fxLayoutAlign="start stretch"
                fxLayout="column"
                #wrapper
                fxFlex="1 1 auto"
                (window:resize)="onResize()"
                >
                @if (!media.isActive('lt-md')) {
                  <section class="checkbox-section">
                    @for (checkLabel of checkLabels; track checkLabel) {
                      <mat-checkbox
                        class="checkbox-margin"
                        [(ngModel)]="checkLabel.completed"
                        (ngModelChange)="onChange()"
                        color="primary"
                        [disabled]="checkLabel.disabled"
                        >{{ checkLabel.name }}</mat-checkbox
                        >
                      }
                    </section>
                  }
                  <div class="div-chart">
                    <google-chart
                      #chart
                      class="chart"
                      type="LineChart"
                      [data]="data"
                      [columns]="labels"
                      [options]="prAnalyzerOptions"
                      [height]="300"
                      [dynamicResize]="false"
                      (select)="onSelect($event)"
                      >
                    </google-chart>
                  </div>
                </div>
              } @else {
                <app-music-note></app-music-note>
              }
            </div>
          }
          @if (!(dataCollectLoading$ | async)) {
            @if (!(dataCollections$ | async)) {
              <img class="datanofix_icon" src="./assets/data_collections.png" />
            } @else {
              <img
                class="datafix_icon"
                matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
                src="./assets/data_collections.png"
                />
              }
            } @else {
              <img class="datanofix_icon" src="./assets/data_collections.png" />
            }
          </mat-card>
        </div>
      }
    }

    <ng-template #noPrAnalyzer>
      <div class="no-product">
        該当データなし
      </div>
    </ng-template>



